import { useMemo } from 'react';
import { useMantineTableDataOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableDataOperations';
import { useDocumentTemplatesQuery } from '@dealstack/frontend/app/pages/DocumentTemplates/api/useDocumentTemplatesQuery';

export const useDocumentTemplatesTable = () => {
	const { templates, isFetching } = useDocumentTemplatesQuery();

	const mantineTableDataOperations = useMantineTableDataOperations();

	const tableData = useMemo(() => templates, [templates]);

	return {
		tableData,
		isLoading: isFetching,
		mantineTableDataOperations,
	};
};
